import React, { useEffect, useState } from "react";
import { Download, X } from "react-feather";
import { usePWAInstall } from "../usePWAInstall";

const SHOW_DELAY = 4000;
const AUTO_HIDE = 5000;

const PWAInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const { install } = usePWAInstall();

  useEffect(() => {
    const isHomePage = window.location.pathname === "/";

    if (!isHomePage) return;

    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    if (standalone) return;

    const dismissed = localStorage.getItem(
      "kadhr_pwa_dismissed"
    );

    if (dismissed) return;

    let showTimer;
    let hideTimer;

    showTimer = setTimeout(() => {
      setShowPrompt(true);

      hideTimer = setTimeout(() => {
        setShowPrompt(false);
      }, AUTO_HIDE);
    }, SHOW_DELAY);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(
      "kadhr_pwa_dismissed",
      "true"
    );

    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="kadhr-install-banner">
      <button
        className="kadhr-install-close"
        onClick={handleDismiss}
        aria-label="Close install prompt"
      >
        <X size={16} />
      </button>

      <div className="kadhr-install-left">
        <div className="kadhr-install-icon">
          <Download size={18} />
        </div>

        <div className="kadhr-install-content">
          <div className="kadhr-install-title">
            Install Kadhr
          </div>

          <div className="kadhr-install-subtitle">
            Add Kadhr to your home screen for faster access, app-like performance.
          </div>

          <button
            className="kadhr-install-btn mt-3"
            onClick={install}
          >
            <Download size={14} />
            Install App
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;